var map = {
	"./agencia-catalana-de-turisme.jpg": 83285,
	"./biosphere.png": 22934,
	"./catalunya-experience.jpg": 87967,
	"./sx3.png": 16117,
	"./terra-de-futurs.jpg": 70602,
	"./vallcebre-espai-actiu.jpg": 65178,
	"./valls-del-pedraforca.jpg": 89676
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 80469;